import { RootState } from 'store/types';
import { oc } from 'ts-optchain';
import { NavigationRoute } from 'react-navigation';
import { createSelector } from 'reselect';

export const navStateSelector = (state: RootState) => state.nav;

export const currentRouteSelector = createSelector(navStateSelector, nav => {
  const findCurrentRoute = (navState: NavigationRoute): NavigationRoute => {
    if (navState.index !== undefined) {
      return findCurrentRoute(navState.routes[navState.index]);
    }

    return navState;
  };

  return findCurrentRoute(nav);
});

export const navigationStateSelector = (state: RootState) => state.navigation;

export const getCurrentRouteName = (navState?: NavigationRoute | null): null | string => {
  if (!navState) return null;

  const route = navState.routes[navState.index];
  const routes = oc(route).routes([]);
  const root = routes.length === 1 && !routes[0].routes;

  if (route.routes && !root) return getCurrentRouteName(route);
  return route.routeName;
};

export const navigationBreadCrumbSelector = createSelector(
  navigationStateSelector,
  navigation => navigation?.breadCrumb || ''
);

export const currentNavigationStateSelector = createSelector(
  navigationStateSelector,
  navigation => navigation?.currentState || ''
);

export const previousNavigationStateSelector = createSelector(
  navigationStateSelector,
  navigation => navigation?.previousState || ''
);

export const currentNavigationRouteNameSelector = createSelector(
  currentNavigationStateSelector,
  currentState => getCurrentRouteName(currentState) || ''
);

export const previousNavigationRouteNameSelector = createSelector(
  previousNavigationStateSelector,
  previousState => getCurrentRouteName(previousState) || ''
);

export const currentNavigationWebStateSelector = createSelector(
  navigationStateSelector,
  navigation => navigation.webState || 'preload'
);
